import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { TinselPayOverviewAchVaultsComponent } from '../tinsel-pay-overview-ach-vaults/tinsel-pay-overview-ach-vaults.component';
import { TinselPayOverviewAchTransactionsComponent } from '../tinsel-pay-overview-ach-transactions/tinsel-pay-overview-ach-transactions.component';
import { TinselPayOverviewCardVaultsComponent } from '../tinsel-pay-overview-card-vaults/tinsel-pay-overview-card-vaults.component';
import { TinselPayOverviewCardTransactionsComponent } from '../tinsel-pay-overview-card-transactions/tinsel-pay-overview-card-transactions.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbTooltip, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-tinsel-pay-overview',
    templateUrl: './tinsel-pay-overview.component.html',
    styleUrls: ['./tinsel-pay-overview.component.css'],
    imports: [NgbTooltip, FaIconComponent, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, TinselPayOverviewCardTransactionsComponent, TinselPayOverviewCardVaultsComponent, TinselPayOverviewAchTransactionsComponent, TinselPayOverviewAchVaultsComponent, NgbNavOutlet]
})
export class TinselPayOverviewComponent implements OnInit {

  // Font Awesome Properties
  faAngleLeft = faAngleLeft;

  constructor(public location: Location) { }

  ngOnInit(): void {

  }
}
